/**
 * px2style.js
 */
var px2style = require('../src_broccoli/px2style.js');

// broccoli-module-px2style
require('../broccoli_modules/basics/basics/image/module.js');
require('../broccoli_modules/basics/interactives/accordion/module.js');
require('../broccoli_modules/basics/interactives/carousel/module.js');
require('../broccoli_modules/basics/interactives/tabs/module.js');

module.exports = px2style;
